import { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { TextareaWithLabel, Typography } from 'shared/ui'
import { TextFieldWithFixedText } from 'shared/ui/TextFieldWithFixedText/TextFieldWithFixedText'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { MAX_PERIODIC_OPT_OUT_MESSAGE_LENGTH } from 'pages/settings/pages/doubleOptIn/store/doubleOptInPageStore'
import styles from './styles.module.scss'

export const DoubleOptInSettingPeriodicOptOut = observer(() => {
  const store = useContext(DoubleOptInPageContext)
  const storeDays = store?.periodicOptOutInstructionsDays
  const [days, setDays] = useState(storeDays?.toString() ?? '30')

  useEffect(() => {
    if (storeDays !== undefined) {
      setDays(storeDays.toString())
    }
  }, [storeDays])

  if (!store) return null

  const handleDaysBlur = (correctedValue: string) => {
    const clampedValue = Number(correctedValue) > 365 ? '365' : correctedValue

    setDays(clampedValue)
    store.setPeriodicOptOutInstructionsDays(Number(clampedValue))
    store.savePeriodicOptOutInstructions()
  }

  return (
    <div className={styles.wrap}>
      <TextareaWithLabel
        labelProps={{}}
        placeholder='Enter opt-out instructions'
        value={store.periodicOptOutInstructionsMessage}
        isError={store.hasPeriodicOptOutInstructionsError}
        onChange={store.setPeriodicOptOutInstructionsMessage}
        onBlur={() => store.savePeriodicOptOutInstructions()}
        limit={MAX_PERIODIC_OPT_OUT_MESSAGE_LENGTH}
        trimOnLimit
        errorType='bottomText'
        rows={1}
        autoResize
        classNameTextarea={styles.messageTextarea}
        resetAction={{
          isVisible: store.isPeriodicOptOutInstructionsMessageEdited,
          onReset: store.resetPeriodicOptOutInstructionsMessage,
        }}
      />
      <div className={styles.daysWrap}>
        <Typography
          variant='text-input-label-small'
          color='var(--content-primary-secondary)'
          ariaLabel='Send every label'
          className={styles.daysLabel}
        >
          Send every
        </Typography>
        <TextFieldWithFixedText
          fixedValue='days'
          value={days}
          defaultValue='30'
          setValue={setDays}
          blurCallback={handleDaysBlur}
        />
      </div>
    </div>
  )
})
